import Vue from 'vue'
import Vuex from 'vuex'
import {categoryList, listByCat, myInfo} from "@/api";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        idCategory:{
            newsCP: '2', //新闻中心父类ID
            noticeCP: '15', //公示公告父类ID
            hrC: '14',//人资栏目ID
            groupC: '1',//集团概况栏目ID
            projectCategory: '33',//重点项目栏目ID
            otherCategory: '34',//其他栏目ID
            zbgg: '16',//公示公告栏目ID
            zcgc: '13',//政策观察栏目ID
            zsgg: '43',//招商公告栏目ID
            zpgg: '19',//招聘公告栏目ID
            ttxw: '35',//首页头条新闻栏目ID
            djjjCP: '36',//党建纪检
        },
        newsClassify: [],
        noticeClassify: [],
        grupList: [],
        hrList: [],
        buildClassify:[],
        userInfo:{},
        supplierInfo:{},
        isLogin: false,
    },
    mutations: {
        NEWS_CLASSIFY(state, data) {
            state.newsClassify = data
        },
        NOTICE_CLASSIFY(state, data) {
            state.noticeClassify = data
        },
        GRUP_LIST(state, data) {
            state.grupList = data
        },
        HR_LIST(state, data) {
            state.hrList = data
        },
        BUILD_CLASSIFY(state, data) {
            state.buildClassify = data
        },
        SET_INFO(state, data) {
            state.supplierInfo = data
        },
        SET_USERINFO(state, data) {
            state.userInfo = data
        },
        SET_LOGIN(state, data) {
            state.isLogin = data
        }
    },
    actions: {
        GetCategoryList({ commit}, params) {
            return new Promise((resolve, reject) => {
                categoryList(params).then(res => {
                    if(params.type == 'news'){
                        //新闻
                        commit('NEWS_CLASSIFY', res.data)
                    }else if(params.type == 'notice'){
                        //公告
                        commit('NOTICE_CLASSIFY', res.data)
                    }else{
                        commit('BUILD_CLASSIFY', res.data)
                    }

                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetArticleList({ commit }, params) {
            return new Promise((resolve, reject) => {
                listByCat(params).then(res => {
                    if(params.type == 'hr'){
                        //人资
                        commit('HR_LIST', res.rows)
                    }else if(params.type == 'group'){
                        //集团概况
                        commit('GRUP_LIST', res.rows)
                    }

                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })

        },
        getMyInfo({ commit }, params) {
            return new Promise((resolve, reject) => {
                myInfo().then(res=>{
                    commit('SET_LOGIN', true)
                    commit('SET_INFO', res.data.supplierInfo)
                    commit('SET_USERINFO', res.data.user)
                    resolve(res)
                }).catch(error => {
                    commit('SET_LOGIN', false)
                    reject(error)
                })
            })

        },
        logout({ commit }, params) {
            return new Promise((resolve, reject) => {
                sessionStorage.clear()
                commit('SET_LOGIN', false)
                commit('SET_INFO', {})
                commit('SET_USERINFO', {})
                resolve()
            })
        },

    },

})

export default store
